"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TooltipSimple_exports = {};
__export(TooltipSimple_exports, {
  TooltipSimple: () => TooltipSimple
});
module.exports = __toCommonJS(TooltipSimple_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("@floating-ui/react");
var import_text = require("@tamagui/text");
var import_Tooltip = require("./Tooltip");
const TooltipSimple = ({
  label,
  children,
  contentProps,
  ...tooltipProps
}) => {
  let context;
  try {
    context = (0, import_react.useDelayGroupContext)();
  } catch {
  }
  const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_Tooltip.Tooltip, { ...tooltipProps, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Tooltip.Tooltip.Trigger, { asChild: true, children }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      import_Tooltip.Tooltip.Content,
      {
        zIndex: 1e6,
        enterStyle: { x: 0, y: -8, opacity: 0, scale: 0.93 },
        exitStyle: { x: 0, y: -8, opacity: 0, scale: 0.93 },
        x: 0,
        scale: 1,
        y: 0,
        elevation: "$1",
        opacity: 1,
        animation: [
          "quick",
          {
            opacity: {
              overshootClamping: true
            }
          }
        ],
        ...contentProps,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Tooltip.Tooltip.Arrow, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_text.Paragraph, { size: "$2", lineHeight: "$0", children: label })
        ]
      }
    )
  ] });
  if (!context) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Tooltip.TooltipGroup, { delay: defaultTooltipDelay, children: contents });
  }
  return contents;
};
const defaultTooltipDelay = { open: 3e3, close: 100 };
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  TooltipSimple
});
//# sourceMappingURL=TooltipSimple.js.map
